var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#062A41",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5769 8.32422H12.461C9.89854 8.32422 8.29187 10.1384 8.29187 12.7067V19.6351C8.29187 22.2034 9.89104 24.0176 12.461 24.0176H19.8144C22.3852 24.0176 23.9844 22.2034 23.9844 19.6351V16.2784",
    stroke: "#05253A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3564 15.1007L19.5839 8.87324C20.3597 8.09824 21.6172 8.09824 22.3931 8.87324L23.4072 9.88741C24.1831 10.6632 24.1831 11.9216 23.4072 12.6966L17.1497 18.9541C16.8106 19.2932 16.3506 19.4841 15.8706 19.4841H12.7489L12.8272 16.3341C12.8389 15.8707 13.0281 15.4291 13.3564 15.1007Z",
    stroke: "#05253A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6376 9.83496L22.4426 13.64",
    stroke: "#05253A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.17993d807af735745c1bd7585f729d12.svg";
export { ForwardRef as ReactComponent };